"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SelectableOffer = exports.InvalidOffer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var Shapes = _interopRequireWildcard(require("../shapes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var generateElementId = function generateElementId(prefix, productType, idx) {
  return "".concat(prefix).concat(productType).concat(idx);
};
var Offers = function Offers(props) {
  var offers = props.offers,
    productType = props.productType,
    selectedOffer = props.selectedOffer,
    onSelection = props.onSelection,
    monthlyIndexSup = props.monthlyIndexSup;
  return offers && offers.length ? /*#__PURE__*/_react.default.createElement("div", null, offers.sort(function (_ref, _ref2) {
    var termA = _ref.productTerm;
    var termB = _ref2.productTerm;
    return termB - termA;
  }).map(function (offer, idx) {
    return offer.isValid && offer.isValidForClient ? /*#__PURE__*/_react.default.createElement(SelectableOffer, {
      monthlyIndexSup: monthlyIndexSup,
      key: idx,
      index: idx,
      productType: productType,
      selectedOffer: selectedOffer,
      offer: offer,
      onSelection: onSelection
    }) : /*#__PURE__*/_react.default.createElement(InvalidOffer, {
      key: idx,
      offer: offer
    });
  })) : null;
};
Offers.propTypes = {
  offers: _propTypes.default.arrayOf(Shapes.Product),
  selectedOffer: _propTypes.default.string,
  productType: _propTypes.default.string,
  onSelection: _propTypes.default.func,
  monthlyIndexSup: _propTypes.default.number
};
var InvalidOffer = function InvalidOffer(_ref3) {
  var offer = _ref3.offer;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "card-offer card-offer--invalid"
  }, /*#__PURE__*/_react.default.createElement("input", {
    disabled: true,
    className: "inputclass offer--disabled",
    type: "radio"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "range"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "range-separator"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Min ", offer.minimumAmount)), /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement("strong", null, "Max ", offer.maximumAmount), " for ", offer.productTerm, " months")), /*#__PURE__*/_react.default.createElement("div", {
    className: "range-xs"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Min ", offer.minimumAmount), /*#__PURE__*/_react.default.createElement("span", null, "Max ", offer.maximumAmount), /*#__PURE__*/_react.default.createElement("span", null, "for ", offer.productTerm, " months")));
};
exports.InvalidOffer = InvalidOffer;
InvalidOffer.propTypes = {
  offer: _propTypes.default.object
};
var SelectableOffer = function SelectableOffer(_ref4) {
  var offer = _ref4.offer,
    index = _ref4.index,
    productType = _ref4.productType,
    selectedOffer = _ref4.selectedOffer,
    onSelection = _ref4.onSelection,
    monthlyIndexSup = _ref4.monthlyIndexSup;
  var checkBoxParentId = generateElementId('checkBox-offer-div-', productType, index);
  var checkBoxWrapperId = generateElementId('radio-input-id-', productType, index);
  var checkBoxParentClasses = (0, _classnames.default)({
    'card-offer--selected': selectedOffer && +offer.id === +selectedOffer,
    'card-offer': +offer.id !== +selectedOffer
  });
  var checkBoxWrapperClasses = (0, _classnames.default)({
    'inputclass--selected': +offer.id === +selectedOffer,
    'inputclass': +offer.id !== +selectedOffer
  });
  var identifier = productType + index;
  return /*#__PURE__*/_react.default.createElement("div", {
    key: checkBoxParentId,
    id: checkBoxParentId,
    className: checkBoxParentClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: checkBoxWrapperId,
    className: checkBoxWrapperClasses
  }, /*#__PURE__*/_react.default.createElement("input", {
    term: offer.productTerm,
    loanamount: offer.loanAmount,
    minimumapr: offer.minimumApr,
    checked: +offer.id === +selectedOffer,
    id: offer.id,
    producttype: productType,
    type: "radio",
    name: "offer",
    className: "card-offer-checkbox",
    value: identifier,
    onChange: onSelection
  })), /*#__PURE__*/_react.default.createElement("label", {
    className: "card-offer-value",
    htmlFor: identifier
  }, /*#__PURE__*/_react.default.createElement("strong", null, offer.minMonthlyPayments, "/mo"), monthlyIndexSup && /*#__PURE__*/_react.default.createElement("sup", {
    className: "disclosure-offeritem"
  }, monthlyIndexSup), /*#__PURE__*/_react.default.createElement("span", null, " (sugg)"), " for ", offer.productTerm, " months", /*#__PURE__*/_react.default.createElement("br", null), "at ", offer.minimumApr, " APR - ", offer.totalCost, " total"));
};
exports.SelectableOffer = SelectableOffer;
SelectableOffer.propTypes = {
  offer: _propTypes.default.object,
  index: _propTypes.default.number,
  productType: _propTypes.default.string,
  selectedOffer: _propTypes.default.string,
  onSelection: _propTypes.default.func,
  monthlyIndexSup: _propTypes.default.number
};
var _default = Offers;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-revisions/dist/pf-revisions.scss');